import { render } from "./CompetitionsList.vue?vue&type=template&id=005ef0bc&scoped=true"
import script from "./CompetitionsList.vue?vue&type=script&lang=js"
export * from "./CompetitionsList.vue?vue&type=script&lang=js"

import "./CompetitionsList.vue?vue&type=style&index=0&id=005ef0bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005ef0bc"]])

export default __exports__